import { dependencies } from '@pn/core/dependencies';
import type { UnitSystem } from '@pn/core/domain/types';
import { useBuildSliceSelector } from '@pn/services/redux/useBuildSliceSelector';
import { appSlice } from './appSlice';

const { actions, name, getInitialState } = appSlice;

export const useAppStorage = () => {
  const useSliceSelector = useBuildSliceSelector(name, getInitialState());

  return {
    isAppInitialized: useSliceSelector((state) => state.isInitialized),
    unitSystem: useSliceSelector((state) => state.unitSystem),
    pageSize: useSliceSelector((state) => state.pageSize),
  };
};

export const appActions = () => {
  const { dispatch } = dependencies.store;

  return {
    initializeApp: () => dispatch(actions.initialize()),
    updateUnitSystem: (unitSystem: UnitSystem) =>
      dispatch(actions.updateUnitSystem(unitSystem)),
    updatePageSize: (pageSize: number) =>
      dispatch(actions.updatePageSize(pageSize)),
  };
};
